// extracted by mini-css-extract-plugin
export default {"highlightedText":"E-agrsqE5RRRYVSni5vRvg=="};